import React, { useEffect } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';

import cookie from 'utils/cookie';
import {
  getAddonsChargeDate,
  getEditChargeDate,
  getDayFromCampaignEndDate,
  getDayPlusSevenFromCampaignEndDate,
} from 'utils/date';
import { VERSION } from 'utils/campaign';
import { PLAN_CODE } from 'utils/user';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import BaseModal from '../BaseModal/Modal';

import styles from './LearnMoreModal.module.css';

const formatTextNoWrap = (text) =>
  `<span style="white-space: nowrap">${text}</span>`;

const LearnMoreModal = ({
  version,
  setVisibility,
  isVisible,
  campaignCurrentWindowEndDate,
  campaignWindowTwoEndDate,
  isSocialEcomm,
  planCode,
}) => {
  const sale = isSocialEcomm ? 'editSocial' : version;
  const cookieName = `fff_${sale}_learnMore_modal`;
  const isCookiePresent = cookie.get(cookieName);
  const formatCampaignEndDate = new Date(campaignCurrentWindowEndDate);
  const closeDate = getDayFromCampaignEndDate(campaignCurrentWindowEndDate);
  const closeDatePlusSeven = getDayPlusSevenFromCampaignEndDate(
    campaignCurrentWindowEndDate
  );
  const dateHtml = `${formatTextNoWrap(closeDate)} at ${formatTextNoWrap(
    '11:59 p.m. PT.'
  )}`;
  const editChargeDateHtml = formatTextNoWrap(
    getEditChargeDate(formatCampaignEndDate)
  );
  const addOnsChargeDateHtml = formatTextNoWrap(
    getAddonsChargeDate(formatCampaignEndDate)
  );
  const closeDateHtml = formatTextNoWrap(closeDatePlusSeven);

  const copy = {
    'add-ons': [
      {
        title: 'Shop the Sale',
        description: `Everything you select will display in your cart. Shop until ${dateHtml}`,
        icon: 'fal fa-shopping-cart',
      },
      {
        title: 'No Checkout Required',
        description: `Everything in your cart will be automatically billed on ${addOnsChargeDateHtml}.`,
        icon: 'fal fa-check-circle',
      },
      {
        title: 'Get Excited',
        description:
          'Your items will generally ship within 1 month of your bill date. Check your inbox for updates.',
        icon: 'fal fa-laugh-beam',
      },
    ],
    edit: [
      {
        title: 'Shop the Sale',
        description: `Everything you select will display in your cart. Shop until ${dateHtml}`,
        icon: 'fal fa-shopping-cart',
      },
      {
        title: 'No Checkout Required',
        description: `Everything in your cart will be automatically billed on ${editChargeDateHtml}.`,
        icon: 'fal fa-check-circle',
      },
      {
        title: 'Get Excited',
        description:
          'Your items will generally ship within 2 weeks of your bill date. Check your inbox for updates.',
        icon: 'fal fa-laugh-beam',
      },
    ],
    editSocial: [
      {
        title: 'Shop the Sale',
        description: `Everything you and your friends select will display in your shared cart. Shop until ${dateHtml}`,
        icon: 'fal fa-shopping-cart',
      },
      {
        title: 'Earn Credit',
        description:
          planCode === PLAN_CODE.fffsocial
            ? 'Get a <strong>$10 credit</strong> to use in the sale when both you and the hosting member purchase a product.'
            : `For each invited friend, earn a <strong>$10 credit</strong> to use in the sale when you both purchase a product. Get an <strong>additional $15 credit</strong> if they sign up for a membership by ${closeDateHtml}.`,
        icon: 'fal fa-badge-dollar',
      },
      {
        title: 'No Checkout Required',
        description: `Everything in your cart will be automatically billed on ${editChargeDateHtml}.`,
        icon: 'fal fa-check-circle',
      },
      {
        title: 'Get Excited',
        description:
          'Your items will generally ship within 2 weeks of your bill date. Check your inbox for updates.',
        icon: 'fal fa-laugh-beam',
      },
    ],
  };
  const content = get(copy, sale, []);

  useEffect(() => {
    if (!isCookiePresent && version !== VERSION.shop) {
      setVisibility(true);
    }
  }, [isCookiePresent, version]);

  const onClose = () => {
    if (!isCookiePresent)
      cookie.set(cookieName, true, '', campaignWindowTwoEndDate);
    setVisibility(false);
  };

  return (
    <BaseModal className={styles.modal} isOpen={isVisible}>
      <div className={styles.container}>
        <h1>How It Works</h1>
        {map(content, (item, key) => (
          <div key={key} className={styles.group}>
            <div className={styles.icon}>
              <i className={item.icon} />
            </div>
            <div className={styles.innerContentWrapper}>
              <p className={styles.title}>{item.title}</p>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.buttonContaier}>
        <Button
          buttonType={BUTTON_TYPES.PRIMARY}
          style={{ width: '386px' }}
          onClick={onClose}
          dataTestId="start-shopping-btn"
        >
          GOT IT, START SHOPPING!
        </Button>
      </div>
    </BaseModal>
  );
};

export default LearnMoreModal;
